import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'Как стать участником программы лояльности?',
      answer: 'Для участия в программе лояльности необходимо зарегистрироваться на сайте и совершить первую покупку. После этого вы автоматически станете участником программы.'
    },
    {
      question: 'Что делать, если не приходит код при регистрации?',
      answer: 'Проверьте папку "Спам" в вашей почте. Если код не пришел, обратитесь в службу поддержки или попробуйте зарегистрироваться повторно.'
    },
    {
      question: 'Как я могу узнать мой баланс бонусов?',
      answer: 'Баланс бонусов отображается в личном кабинете в разделе "Программа лояльности". Также вы можете узнать баланс, обратившись в службу поддержки.'
    },
    {
      question: 'Я совершил покупку, но бонусы еще не начислили. Почему?',
      answer: 'Бонусы начисляются в течение 24 часов после подтверждения заказа. Если прошло больше времени, обратитесь в службу поддержки.'
    },
    {
      question: 'Вопрос качества?',
      answer: 'Мы работаем только с проверенными поставщиками и предоставляем гарантию на все товары. В случае обнаружения дефекта, товар можно вернуть или обменять.'
    },
    {
      question: 'Как долго ждать заказ?',
      answer: 'Сроки доставки зависят от региона и наличия товара на складе. Обычно заказы доставляются в течение 1-3 рабочих дней.'
    },
    {
      question: 'Как оформить запрос?',
      answer: 'Запрос можно оформить через форму обратной связи на сайте, по телефону или через личный кабинет в разделе "Поддержка".'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-8 md:py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-12 items-start">
          {/* Левая колонка - заголовок и описание */}
          <div className="lg:col-span-1">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 md:mb-4 mt-0">
              Вопрос-ответ
            </h2>
            <p className="text-base md:text-lg text-gray-600">
              Часто задаваемые вопросы и ответы на них
            </p>
          </div>
          
          {/* Правая колонка - список вопросов */}
          <div className="lg:col-span-2">
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg shadow-sm border border-gray-200"
                >
                  <button
                    className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors duration-200"
                    onClick={() => toggleFAQ(index)}
                  >
                    <span className="font-medium text-gray-900">{faq.question}</span>
                    <ChevronDownIcon
                      className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    />
                  </button>
                  {openIndex === index && (
                    <div className="px-6 pt-2 pb-4">
                      <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
